import React, { useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import { AccountsList } from './AccountsList';
import { AccountsGraph } from '../../components/AccountsGraph';
import { CONTAINER_CONTENT_CLASS } from '../signatures/SignaturesRoutes';
import { usePageHeader } from '../../contexts/PageHeaderContext';

interface AccountsWithDashboardProps {
    viewType?: 'list' | 'dashboard';
}

export function AccountsWithDashboard({ viewType = 'list' }: AccountsWithDashboardProps) {
    const location = useLocation();
    const { setPageHeader } = usePageHeader();
    
    usePageTitle('Accounts');
    
    const isListView = viewType === 'list';
    const isDashboardView = viewType === 'dashboard';

    // Create navigation items with useMemo to prevent recreating on every render
    const navigationItems = useMemo(() => (
        <div className="flex gap-4 text-sm">
            <Link 
                to="/management/accounts/list" 
                className={isListView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                List View
            </Link>
            <Link 
                to="/management/accounts/dashboard"
                className={isDashboardView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                Dashboard
            </Link>
        </div>
    ), [isListView, isDashboardView]);

    useEffect(() => {
        setPageHeader('Accounts', navigationItems);
        
        return () => setPageHeader(null);
    }, [navigationItems, setPageHeader]);

    return (
        <div className="container-fixed">
            {isListView ? <AccountsList /> : <AccountsGraph />}
        </div>
    );
}